import { Field, Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import * as Yup from 'yup'

export default function LoginForm({ loginError, handleSubmit }) {
  // Esquema de validación del formulario (POST o PUT):
  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Correu invàlid').required('Introduïu un correu'),
    password: Yup.string().required('Introduïu una contrasenya')
  })

  return (
    <>
      <Formik
        initialValues={{
          email: '',
          password: ''
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values)
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div>
              <label
                htmlFor="email"
                className={`${touched.email && errors.email ? 'text-red-700 dark:text-red-500' : 'text-gray-700 dark:text-gray-200'}`}
              >
                Correo
              </label>

              <Field
                id="email"
                name="email"
                type="email"
                className={`block w-full p-2 mt-2 border bg-white rounded-sm focus:ring-opacity-40 focus:outline-none focus:ring ${touched.email && errors.email ? 'border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500' : ' text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-blue-300 dark:focus:border-blue-300'}`}
                autoComplete="new-password"
                placeholder="example@example.com"
              />

              <div
                className={`flex justify-start items-start w-full ${touched.email && errors.email ? 'visible' : 'invisible'}`}
              >
                <div className="flex w-full">
                  <p className="mt-1 text-sm leading-none text-red-600">
                    {errors.email || '\u00A0'}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-4">
              <div className="flex items-end justify-between mb-2">
                <label
                  htmlFor="password"
                  className={`${touched.password && errors.password ? 'text-red-700 dark:text-red-500' : 'text-gray-700 dark:text-gray-200'}`}
                >
                  Contraseña
                </label>

                <a
                  href="#"
                  className="text-sm text-gray-400 focus:text-blue-500 hover:text-blue-500 hover:underline"
                >
                  ¿Olvidó su contraseña?
                </a>
              </div>

              <Field
                id="password"
                name="password"
                type="password"
                className={`block w-full p-2 mt-2 border bg-white rounded-sm focus:ring-opacity-40 focus:outline-none focus:ring ${touched.password && errors.password ? 'border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500' : ' text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-blue-300 dark:focus:border-blue-300'}`}
                autoComplete="new-password"
              />

              <div
                className={`flex justify-start items-start w-full ${touched.password && errors.password ? 'visible' : 'invisible'}`}
              >
                <div className="flex w-full">
                  <p className="mt-1 text-sm leading-none text-red-600">
                    {errors.password || '\u00A0'}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-5">
              <button
                type="submit"
                className="flex items-center justify-center w-full px-5 py-2 text-white capitalize transition-colors duration-200 bg-[#FCAE52] border border-[#FCAE52] rounded-sm gap-x-2 enabled:hover:bg-white enabled:hover:text-[#FCAE52] dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:enabled:hover:bg-gray-800 disabled:opacity-30 focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-[#FCAE52] focus:border-[#FCAE52] dark:focus:border-[#FCAE52]"
              >
                Iniciar sesión
              </button>
            </div>

            <div
              className={`relative text-sm px-2 py-1 mt-2 text-red-600 bg-red-100 border border-red-600 rounded-sm ${loginError ? 'visible' : 'invisible'}`}
              role="alert"
            >
              <strong className="font-bold">Error: </strong>
              <span className="block sm:inline">{loginError}</span>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

// Define los tipos de las props que recibe el componente actual
LoginForm.propTypes = {
  loginError: PropTypes.any,
  handleSubmit: PropTypes.func
}
